import {
  FALLBACK_DISCOUNT_CODE_PRICE,
  STARTER_KIT_PRICE,
} from "@/lib/utils/common/constants";
import { getHeroBadgeText } from "@/lib/config/sale";

const NG_HERO_ORIGINAL_PRICE = STARTER_KIT_PRICE.ng;
const NG_HERO_DISCOUNTED_PRICE =
  STARTER_KIT_PRICE.ng - FALLBACK_DISCOUNT_CODE_PRICE.ng;

// Callers set display (inline-flex / hidden): a base display class would win over
// `hidden` in Tailwind 4's utility order.
export function LaunchOfferPill({
  className,
  testId,
}: {
  className?: string;
  testId: string;
}) {
  return (
    <p
      id={testId}
      data-testid={testId}
      className={`w-fit items-center gap-[10px] rounded-[10px] px-[10px] py-2 text-[14px] font-medium leading-[24.74px] tracking-[-0.0265em] text-white backdrop-blur-[17.5px] ${className ?? ""}`}
    >
      <span
        className="inline-flex items-center justify-center rounded-[3.71px] px-[7.42px] py-[2.47px] text-[14px] font-medium uppercase leading-[19.79px] tracking-[-0.01em] text-[#F3F4ED]"
        style={{
          background:
            "linear-gradient(9deg, rgba(250, 86, 39, 1) 0%, rgba(250, 86, 39, 1) 43%, rgba(255, 156, 64, 1) 100%)",
        }}
      >
        {getHeroBadgeText()}
      </span>
      <span>
        <s className="text-[#857E77]">${NG_HERO_ORIGINAL_PRICE}</s>
        {"  "}${NG_HERO_DISCOUNTED_PRICE}
      </span>
    </p>
  );
}
